import { render, staticRenderFns } from "./QuizNightPreview.vue?vue&type=template&id=2fdb0143&scoped=true"
import script from "./QuizNightPreview.vue?vue&type=script&lang=js"
export * from "./QuizNightPreview.vue?vue&type=script&lang=js"
import style0 from "./QuizNightPreview.vue?vue&type=style&index=0&id=2fdb0143&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdb0143",
  null
  
)

export default component.exports